<template>
  <f7-page>
    <div v-if="isProd && instanceID !== 'jhgBCtmfWOybCYHlAoak'">
      Proximamente...
    </div>
    <div v-else>
      <div class="mx-auto w-11/12 sm:w-7/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl">
        <div class="sm:flex items-center">
          <img
            class="block mx-auto sm:mx-0 h-48"
            src="@/assets/campaign.svg"
            alt="Campañas"
          >
          <div class="text-center self-center sm:ml-2 text-2xl sm:text-4xl font-bold sm:text-left">
            Campañas
          </div>
        </div>
        <a
          class="sm:w-64 cursor-pointer text-white bg-purple-500 flex px-4 py-2 rounded-md items-center text-md my-5 hover:bg-purple-400"
          href="/admin/campaign/create/"
        >
          <eva-icon
            name="plus-outline"
            fill="#FFFFFF"
          />
          <div
            class="block-inline text-center w-full pointer"
          >
            Crear campaña
          </div>
        </a>
        <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
          <div class="inline-block min-w-full shadow-md border border-gray-300 rounded-lg overflow-hidden">
            <table class="min-w-full leading-normal">
              <thead>
                <tr class="bg-bluegray-500">
                  <th
                    scope="col"
                    class="px-5 py-3  border-b border-gray-200 text-gray-800 text-sm font-normal"
                  >
                    Nombre
                  </th>
                  <th
                    scope="col"
                    class="px-5 py-3  border-b border-gray-200 text-gray-800 text-sm font-normal"
                  >
                    Estado
                  </th>
                  <th
                    scope="col"
                    class="px-5 py-3  border-b border-gray-200 text-gray-800 text-sm font-normal"
                  >
                    Progreso
                  </th>
                  <th
                    scope="col"
                    class="px-5 py-3  border-b border-gray-200 text-gray-800 text-sm font-normal"
                  >
                    Exportar
                  </th>
                  <th
                    scope="col"
                    class="px-5 py-3  border-b border-gray-200 text-gray-800 text-sm font-normal"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="campaign in campaigns"
                  :key="campaign.id"
                >
                  <td class="px-5 py-5 border-b border-gray-200 bg-white">
                    <div class="ml-3">
                      <p class="text-gray-900 whitespace-no-wrap">
                        {{ campaign.name }}
                      </p>
                    </div>
                  </td>
                  <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                    <span :class="`relative inline-block px-3 py-1 font-semibold ${isActive(campaign) ? 'text-green-900' : 'text-gray-600'} leading-tight`">
                      <span
                        aria-hidden="true"
                        :class="`absolute inset-0 ${isActive(campaign) ? 'bg-green-200' : 'bg-gray-300'} opacity-50 rounded-full`"
                      />
                      <span class="relative">
                        {{ isActive(campaign) ? 'activa' : 'inactiva' }}
                      </span>
                    </span>
                  </td>
                  <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                    <div>
                      <div class="w-full h-6 bg-purple-200 rounded-full flex items-center p-1">
                        <div
                          class="h-full bg-purple-500 rounded-full"
                          :style="`width: ${campaignsProgress[campaign.id]}%`"
                        />
                      </div>
                      <div class="w-full text-center text-xs text-purple-500 mt-1 font-semibold">
                        {{ campaignsProgress[campaign.id] }}%
                      </div>
                    </div>
                  </td>
                  <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                    <a
                      class="sm:w-64 cursor-pointer text-white bg-purple-500 p-2 rounded-md items-center text-md my-5 hover:bg-purple-400"
                      @click="exportAnswers(campaign.id, campaign)"
                    >
                      <eva-icon
                        class="align-middle"
                        name="download-outline"
                        fill="#FFFFFF"
                      />
                    </a>
                  </td>
                  <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                    <a
                      v-if="!isActive(campaign)"
                      class="sm:w-64 cursor-pointer mr-4"
                      @click="$f7router.navigate('/admin/campaign/edit/', { props: { campaign: campaign, campaignID: campaign.id } })"
                    >
                      <eva-icon
                        class="align-middle hover:opacity-75"
                        name="edit-outline"
                        fill="#6C63FF"
                      />
                    </a>
                    <a
                      class="sm:w-64 cursor-pointer"
                      @click="remove(campaign.id)"
                    >
                      <eva-icon
                        class="align-middle hover:opacity-75"
                        name="trash-outline"
                        fill="#FF7570"
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment-timezone'
import { db } from '../utils/firebase'
import * as axios from 'axios'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
  data () {
    return {
      campaigns: {},
      campaignsBind: null,
    }
  },
  computed: {
    isProd () {
      return process.env.NODE_ENV === 'production'
    },
    campaignsProgress () {
      const percentages = {}
      for (const [key, value] of Object.entries(this.campaigns)) {
        console.info(value.metrics)
        const answeredBy = value.metrics?.answeredByCount || 0
        percentages[key] = Math.round((answeredBy || 0) * 100 / value.metrics?.targetCount) || 0
      }
      return percentages
    },
    ...mapState({
      persons: state => state.admin.persons,
      instanceID: state => state.admin.instanceID,
      instancesInfo: state => state.auth.instancesInfo,
    }),
  },
  mounted () {
    if (this.campaignsBind === null) {
      this.campaignsBind = db.collection('campaigns').where('instanceID', '==', this.instanceID).onSnapshot(snap => {
        if (!snap.empty) {
          snap.docChanges().forEach(change => {
            if (change.type === 'added' || change.type === 'modified') {
              this.$set(this.campaigns, change.doc.id, {
                id: change.doc.id,
                ...change.doc.data(),
              })
            } else {
              this.$delete(this.campaigns, change.doc.id)
            }
          })
        } else {
          this.campaigns = {}
        }
      }, (err) => { console.info(err.code) })
    }
  },
  beforeDestroy () {
    if (this.campaignsBind !== null) this.campaignsBind()
  },
  methods: {
    async exportAnswers (campaignID, campaign) {
      try {
        const answersByFieldQuery = await db.collection('campaigns').doc(campaignID).collection('answersByField').doc('answersByField').get()
        const answersByField = answersByFieldQuery.data().answers
        console.info(answersByField)
        const todayDate = moment().tz('America/Bogota').startOf('day').format('DD-MM-YY')
        const wb = XLSX.utils.book_new()
        const csvTitle = 'Encuesta'
        const name = `Cuidarte-${todayDate}-${csvTitle}.xlsx`
        const questions = []
        for (const categoryID of Object.keys(answersByField)) {
          const labels = Object.keys(campaign.form.categories[categoryID].fields).map((fieldID) => {
            return campaign.form.categories[categoryID].fields[fieldID].label
          })
          console.info(labels)
          for (const label of labels) {
            questions.push((campaign.name) + ': ' + label)
          }
        }
        const complete = [
          ['Nombre', 'Celular', 'ID', 'email', ...questions],
          ...this.persons.map(person => {
            const personAnswers = []
            for (const categoryID of Object.keys(answersByField)) {
              for (const fieldID of Object.keys(answersByField[categoryID])) {
                if (answersByField[categoryID][fieldID] && answersByField[categoryID][fieldID][person.id]) {
                  personAnswers.push('X')
                } else {
                  personAnswers.push('')
                }
              }
            }
            return [person.name, person.phoneNumber, person.documentID, person.email, ...personAnswers]
          })
        ]
        const w1 = XLSX.utils.aoa_to_sheet(complete)
        XLSX.utils.book_append_sheet(wb, w1, csvTitle.substring(0, 28) + (csvTitle.length >= 28 ? '...' : ''))

        const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' }
        const wbout = XLSX.write(wb, wopts)
        const xlsx = new Blob([wbout], { type: 'application/octet-stream' })

        if (typeof window.plugins !== 'undefined') {
          var reader = new FileReader()
          this.$f7.dialog.preloader('Cargando...')
          reader.readAsDataURL(xlsx)
          reader.onloadend = () => {
            this.$f7.dialog.close()
            const base64data = reader.result
            window.plugins.socialsharing.share(
              null,
              null,
              this.generateAttachment(base64data, name),
              null,
              (result) => { console.info('result: ' + result) },
              (result) => { console.info('error: ' + result) }
            )
          }
        } else {
          saveAs(xlsx, name)
        }
      } catch (err) {
        console.info(err)
        this.$f7.dialog.alert('Hubo un problema descargando este informe', 'Error')
      }
    },
    async remove (campaignID) {
      this.$f7.dialog.confirm(`¿Estás seguro de que deseas eliminar la campaña <span class="text-purple-500 font-bold">${this.campaigns[campaignID].name}</span>?`, '¿Seguro?', async () => {
        try {
          const data = {
            campaignID,
          }
          this.$f7.dialog.preloader('Eliminando campaña')
          await axios({
            url: '/campaigns/remove',
            method: 'POST',
            data,
          })
          this.$f7.dialog.close()
        } catch (err) {
          console.error(err)
          this.$f7.dialog.close()
        }
      })
    },
    isActive (campaign) {
      const today = moment.tz('America/Bogota').startOf('day')
      const endDate = moment(campaign.dates.end.toMillis()).tz('America/Bogota')
      const startDate = moment(campaign.dates.start.toMillis()).tz('America/Bogota')
      return today.isBetween(startDate, endDate)
    },
  },
}
</script>
